// Barra de cookies (LGPD, 24/10/2026). Só no site: o Meta Pixel e o Google
// Analytics só carregam depois do aceite (ver lib/cookies.js e o
// public/index.html). Aparece uma vez, depois da abertura, sem tela escura e
// sem disputar espaço com outro aviso; "Preferências de cookies" na Política
// de Privacidade reabre para mudar a escolha.
import React, { useEffect, useState } from 'react';
import { Btn } from './ui';
import { ehNativo } from '../services/nativo';
import { depoisDaAbertura } from '../lib/abertura';
import {
  EVENTO_ABRIR_COOKIES, lerConsentimento, salvarConsentimento, temRastreadores,
} from '../lib/cookies';

const algoAberto = () => {
  try {
    return !!document.querySelector('[role="dialog"], .ta-abertura, [data-aviso-flutuante="nova-versao"]')
      || !!window.__tutorialAberto;
  } catch (e) { return false; }
};

const Chave = ({ id, titulo, texto, ligado, onChange, fixo = false }) => (
  <label htmlFor={id} className={`flex items-start gap-3 py-2.5 ${fixo ? '' : 'cursor-pointer'}`}>
    <span className="min-w-0 flex-1">
      <span className="block text-[13px] font-bold text-[#12192a]">{titulo}</span>
      <span className="block text-[12px] text-slate-500 leading-snug">{texto}</span>
    </span>
    <input id={id} type="checkbox" role="switch" checked={ligado} disabled={fixo}
      onChange={(e) => onChange && onChange(e.target.checked)}
      className="mt-1 w-5 h-5 flex-shrink-0 accent-orange-500 disabled:opacity-60" />
  </label>
);

export const BannerCookies = ({ nav, semBarra = false }) => {
  const [visivel, setVisivel] = useState(false);
  const [configurando, setConfigurando] = useState(false);
  const [medicao, setMedicao] = useState(false);
  const [anuncios, setAnuncios] = useState(false);
  const disponivel = !ehNativo() && temRastreadores();

  // 1ª visita: aparece depois da abertura, quando nada mais estiver na tela
  useEffect(() => {
    if (!disponivel || lerConsentimento()) return undefined;
    let t = null;
    const tentar = () => {
      if (algoAberto()) { t = setTimeout(tentar, 2500); return; }
      setVisivel(true);
    };
    const cancelar = depoisDaAbertura(() => { t = setTimeout(tentar, 1200); });
    return () => { cancelar(); if (t) clearTimeout(t); };
  }, [disponivel]);

  // Reabrir pelas "Preferências de cookies", já com a escolha atual
  useEffect(() => {
    if (!disponivel) return undefined;
    const abrir = () => {
      const c = lerConsentimento() || {};
      setMedicao(!!c.medicao);
      setAnuncios(!!c.anuncios);
      setConfigurando(true);
      setVisivel(true);
    };
    window.addEventListener(EVENTO_ABRIR_COOKIES, abrir);
    return () => window.removeEventListener(EVENTO_ABRIR_COOKIES, abrir);
  }, [disponivel]);

  if (!disponivel || !visivel) return null;

  const escolher = (c) => { salvarConsentimento(c); setVisivel(false); setConfigurando(false); };

  return (
    <div role="region" aria-label="Preferências de cookies" data-aviso-flutuante="cookies"
      className={`fixed left-3 right-3 z-[850] md:left-auto md:right-6 md:max-w-md
                  ${semBarra ? 'bottom-[max(1rem,env(safe-area-inset-bottom))]' : 'bottom-[max(5.5rem,calc(env(safe-area-inset-bottom)+5rem))]'} md:bottom-6`}>
      <div className="rounded-2xl bg-white shadow-[0_10px_34px_rgba(2,6,23,0.18)] ring-1 ring-black/5 p-4">
        <p className="font-extrabold text-[14px] text-[#12192a] m-0">Cookies</p>
        <p className="text-[12.5px] text-slate-600 mt-1 mb-0 leading-snug">
          Usamos cookies para medir as visitas e para anúncios do Tô Alugando. Os essenciais (login e segurança) ficam sempre ligados.{' '}
          <button type="button" onClick={() => nav && nav('privacidade')} className="text-orange-600 font-semibold underline underline-offset-2">
            Política de Privacidade
          </button>
        </p>

        {configurando && (
          <div className="mt-2 divide-y divide-slate-100">
            <Chave id="ck-essenciais" titulo="Essenciais" texto="Login, carrinho e proteção contra fraude. Sem eles o site não funciona." ligado fixo />
            <Chave id="ck-medicao" titulo="Medição de audiência" texto="Google Analytics: quais páginas são visitadas e de onde a visita veio." ligado={medicao} onChange={setMedicao} />
            <Chave id="ck-anuncios" titulo="Anúncios" texto="Meta (Facebook e Instagram): medir campanhas e mostrar anúncios a quem já visitou." ligado={anuncios} onChange={setAnuncios} />
          </div>
        )}

        <div className="flex flex-wrap gap-2 mt-3">
          {configurando ? (
            <>
              <Btn v="white" sz="sm" onClick={() => escolher({ medicao: false, anuncios: false })}>Recusar tudo</Btn>
              <Btn v="primary" sz="sm" className="flex-1" onClick={() => escolher({ medicao, anuncios })}>Salvar escolhas</Btn>
            </>
          ) : (
            <>
              <Btn v="white" sz="sm" onClick={() => escolher({ medicao: false, anuncios: false })}>Recusar</Btn>
              <Btn v="ghost" sz="sm" onClick={() => setConfigurando(true)}>Configurar</Btn>
              <Btn v="primary" sz="sm" className="flex-1" onClick={() => escolher({ medicao: true, anuncios: true })}>Aceitar</Btn>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default BannerCookies;
